{
  "CANNED_MGMT": {
    "HEADER": "Hazır Yanıtlar",
    "LEARN_MORE": "Learn more about canned responses",
    "DESCRIPTION": "Canned Responses are pre-written reply templates that help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a canned response during a conversation. ",
    "HEADER_BTN_TXT": "Hazır yanıt ekle",
    "LOADING": "Hazır yanıtlar getiriliyor...",
    "SEARCH_404": "Bu sorgu ile eşleşen öğe yok.",
    "LIST": {
      "404": "Bu hesapta hazır yanıt yok.",
      "TITLE": "Hazır yanıtları yönetin",
      "DESC": "Hazır Yanıtlar, konuşmalara hızlı yanıt vermek için kullanılan önceden tanımlanmış yanıt şablonlarıdır.",
      "TABLE_HEADER": {
        "SHORT_CODE": "Kısa Kod",
        "CONTENT": "İçerik",
        "INBOXES": "Gelen kutuları",
        "ACTIONS": "Hareketler"
      },
      "ALL_INBOXES": "Tüm gelen kutuları",
      "FILTER": {
        "ALL_INBOXES": "Tüm gelen kutuları",
        "NO_INBOX": "Gelen kutusu yok",
        "SEARCH_PLACEHOLDER": "Gelen kutularında ara"
      }
    },
    "ADD": {
      "TITLE": "Hazır yanıt ekle",
      "DESC": "Hazır Yanıtlar, konuşmalara hızlı yanıt vermek için kullanılan önceden tanımlanmış yanıt şablonlarıdır.",
      "CANCEL_BUTTON_TEXT": "İptal Et",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Kısa Kod",
          "PLACEHOLDER": "Lütfen bir kısa kod girin.",
          "ERROR": "Kısa Kod gerekli."
        },
        "SUBJECT": {
          "LABEL": "Konu (yalnızca e-posta)",
          "PLACEHOLDER": "E-posta yanıtları / yeni konuşmalar için isteğe bağlı konu"
        },
        "CONTENT": {
          "LABEL": "Mesaj",
          "PLACEHOLDER": "Lütfen daha sonra kullanmak üzere şablon olarak kaydetmek istediğiniz mesajı yazın.",
          "ERROR": "Mesaj gerekli."
        },
        "ATTACHMENTS": {
          "LABEL": "Ekler"
        },
        "INBOXES": {
          "LABEL": "Gelen kutuları",
          "PLACEHOLDER": "Gelen kutularını seçin (isteğe bağlı, tüm gelen kutuları için boş bırakın)"
        },
        "SUBMIT": "Gönder"
      },
      "API": {
        "SUCCESS_MESSAGE": "Hazır yanıt başarıyla eklendi.",
        "ERROR_MESSAGE": "Woot sunucusuna bağlanılamadı. Lütfen tekrar deneyin."
      }
    },
    "EDIT": {
      "TITLE": "Hazır yanıtı düzenle",
      "CANCEL_BUTTON_TEXT": "İptal Et",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Kısa Kod",
          "PLACEHOLDER": "Lütfen bir kısa kod girin.",
          "ERROR": "Kısa kod gerekli."
        },
        "SUBJECT": {
          "LABEL": "Konu (yalnızca e-posta)",
          "PLACEHOLDER": "E-posta yanıtları / yeni konuşmalar için isteğe bağlı konu"
        },
        "CONTENT": {
          "LABEL": "Mesaj",
          "PLACEHOLDER": "Lütfen daha sonra kullanmak üzere şablon olarak kaydetmek istediğiniz mesajı yazın.",
          "ERROR": "Mesaj gerekli."
        },
        "ATTACHMENTS": {
          "LABEL": "Ekler"
        },
        "INBOXES": {
          "LABEL": "Gelen kutuları",
          "PLACEHOLDER": "Gelen kutularını seçin (isteğe bağlı, tüm gelen kutuları için boş bırakın)"
        },
        "SUBMIT": "Gönder"
      },
      "BUTTON_TEXT": "Düzenle",
      "API": {
        "SUCCESS_MESSAGE": "Hazır yanıt başarıyla güncellendi.",
        "ERROR_MESSAGE": "Woot sunucusuna bağlanılamadı. Lütfen tekrar deneyin."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Sil",
      "API": {
        "SUCCESS_MESSAGE": "Hazır yanıt başarıyla silindi.",
        "ERROR_MESSAGE": "Woot sunucusuna bağlanılamadı. Lütfen tekrar deneyin."
      },
      "CONFIRM": {
        "TITLE": "Silme işlemini onayla",
        "MESSAGE": "Silmek istediğinize emin misiniz?",
        "YES": "Evet, sil ",
        "NO": "Hayır, sakla "
      }
    }
  }
}
